import { ChangePassword } from "./ChangePassword";
import { TwoFactorAuthentication } from "./TwoFactorAuthentication";
import { SecurityWrapper } from "./Security.styles";

export const Security = () => {
  return (
    <SecurityWrapper>
      <div className="authentication-container">
        <TwoFactorAuthentication />
      </div>
      <ChangePassword />
    </SecurityWrapper>
  );
};
